import _ from 'lodash';
import Section from "../components/Section";
import {Button} from "../components/Button";
import docsBackground from '../assets/backgrounds/documents.jpg';
import UIState from "../store/uiState";
import {
    CLAIMING_DISABLED,
    ContractAddresses,
    ModalTypes,
    STAKING_DISABLED
} from "../constants";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";
import {formatBalance, truncate} from "../utils";
import Wallet from "../store/models/wallet";
import React, {useEffect, useState} from "react";
import {usePageVisibility} from "../hooks/usePageVisibility";
import {pushTo} from "../utils/history";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import logo from "../assets/logos/pog@2x.png";
import {StakeAPYInfo} from "../components/CTAPill";
import thetaWalletLogo from "../assets/wallets/theta-wallet-white@2x.png";
import metamaskLogo from "../assets/wallets/metamask-white@2x.png";

export const selectCurrentAccount = state => state?.models?.currentAccount;
export const selectCurrentBalances = state => state?.models?.balances;
export const selectNftTokenIds = state => state?.models?.nftTokenIds;

const ClaimPage = () => {
    const {t} = useTranslation();
    const isVisible = usePageVisibility();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const account = useSelector(selectCurrentAccount);
    const balances = useSelector(selectCurrentBalances);
    let nftTokenIds = useSelector(selectNftTokenIds);
    const [amount,setAmount] = useState('');
    const onClaim = () => {
        // Fetch token ids
        let tokenIds = _.take(nftTokenIds, parseInt(amount));
        dispatch(Wallet.actions.claim(tokenIds));
    }

    const onMetaMask = () => {
        dispatch(Wallet.actions.loginWithMetamask());
    }

    const onThetaWallet = () => {
        dispatch(Wallet.actions.loginWithWalletConnect());
    }

    const onDisconnect = () => {
        dispatch(Wallet.actions.disconnect());
    }

    const onStake = () => {
        navigate('/stake');
    }

    const onAll = () => {
        setAmount(nftTokenIds.length)
    }

    useEffect(() => {
        (async () => {
            await dispatch(Wallet.actions.tryToRecoverWalletSession());
            dispatch(Wallet.actions.getNftTokenIds());
        })();
    }, []);

    useEffect(() => {
        if (isVisible && account && !_.isEmpty(balances)) {
            dispatch(Wallet.actions.getBalances());
            dispatch(Wallet.actions.getNftTokenIds());
        }
    }, [isVisible, account]);

    return (
        <div className={'Page ClaimPage'}>
            <Section className={'TopSection'}>
                {
                    _.isNil(account) &&
                    <div className={'SectionContainer'}>
                        <img src={logo}
                             className={'StakePage__logo'}
                        />
                        <h1>
                            {t('claim.title')}
                        </h1>
                        <p>
                            {t('claim.description')}
                        </p>

                        <div className={'ConnectYourWallet'}>
                            <div className={'ConnectYourWallet__title'}>
                                {t('stake.connect_your_wallet')}
                            </div>
                            <div className={'ConnectYourWallet__options'}>
                                <div className={'ConnectYourWallet__option'}>
                                    <Button size={'large'}
                                            title={'Theta Wallet'}
                                            className={'ConnectWalletButton'}
                                            onClick={onThetaWallet}
                                    >
                                        <img src={thetaWalletLogo}/>
                                    </Button>
                                    <div className={'ConnectWalletButtonAttachment'}>
                                        {t('stake.available_on_ios_and_android')}
                                    </div>
                                </div>
                                <div className={'ConnectYourWallet__option'}>
                                    <Button size={'large'}
                                            title={'Metamask'}
                                            className={'ConnectWalletButton'}
                                            onClick={onMetaMask}
                                    >
                                        <img src={metamaskLogo}/>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !_.isNil(account) &&
                    <div className={'SectionContainer'}>
                        {
                            CLAIMING_DISABLED &&
                            <div className={'WarningMessage'}>
                                {t('claim.paused_message')}
                            </div>
                        }


                        <p className={'ClaimPage__connection'}>
                            <span className={'ClaimPage__connection-title'}>Connected to: </span>
                            <span className={'ClaimPage__connection-account'}>{truncate(account)}</span>
                            <a className={'ClaimPage__connection-disconnect'}
                               onClick={onDisconnect}>
                                {t('claim.disconnect')}
                            </a>
                        </p>

                        <h1>
                            {t('claim.burn_title')}
                        </h1>

                        <div className={'AccountBalances'}>
                            <div className={'AccountBalanceRow'}>
                                <div className={'AccountBalanceRow__title'}>
                                    {t('claim.balance')}
                                </div>
                                <div className={'AccountBalanceRow__value'}>
                                    {formatBalance(balances?.governanceTokenOnHand)}
                                </div>
                            </div>
                        </div>

                        {
                            balances?.governanceTokenOnHand > 0 &&
                            <Button color={'pink'}
                                    size={'medium'}
                                    className={'ClaimPage__stake-button'}
                                    onClick={onStake}
                            >
                                {t('claim.stake')}
                            </Button>
                        }


                        <div className={'ClaimPage__claimable-cards'}>


                        </div>

                        {
                            nftTokenIds.length > 0 &&
                            <div className={'BurnAndRedeem'}>
                                <img className={'BurnAndRedeem__img'}
                                     src={'https://user-assets-thetadrop.imgix.net/user_1rcb3xuebbg33xv45hcvnksaeed/coll_7k5765ne3f8nyi8q194mz6b9u9n/type/image-1707860705311.jpg?w=488'}/>
                                <div className={'BurnAndRedeem__owned'}>
                                    <div className={'BurnAndRedeem__owned-title'}>
                                        {t('claim.owned')}
                                    </div>
                                    <div className={'BurnAndRedeem__owned-amount'}>
                                        {nftTokenIds.length}
                                    </div>
                                </div>
                                <div className={'ActionInputWrapper'}>
                                    <div className={'Input'}>
                                        <input value={amount}
                                               onChange={(e) => setAmount(e.target.value)}
                                               placeholder={t('claim.enter_amount')}
                                               type="number"
                                               max={nftTokenIds.length}
                                               min={0}
                                        />
                                        <Button color={'grey'}
                                                size={'xsmall'}
                                                onClick={onAll}
                                        >
                                            {t('claim.all')}
                                        </Button>
                                    </div>

                                    <Button color={'pink'}
                                            size={'medium'}
                                            onClick={onClaim}
                                    >
                                        {t('claim.burn')}
                                    </Button>
                                </div>
                                <div className={'BurnAndRedeem__reward'}>
                                    Earn 100 $POGS per NFT burned
                                </div>
                            </div>
                        }

                        {
                            nftTokenIds.length === 0 &&
                            <div className={'ClaimPage__no-nfts'}>
                                <h3>{t('claim.no_nfts.title')}</h3>
                                <p>{t('claim.no_nfts.subtitle')}</p>
                                <Button className={'ClaimPage__burn-all-button'}
                                        color={'transparent-green'}
                                        size={'medium'}
                                        href={'https://pog.thetadrop.com/'}
                                >
                                    {t('claim.no_nfts.button')}
                                </Button>
                            </div>
                        }

                    </div>
                }
            </Section>
        </div>
    )
};

export default ClaimPage;